export default __webpack_public_path__ + "static/media/icaew_background_s1.f723b8ac.jpg";